export const RESET_GET_DISCOUNT_FORM = 'RESET_GET_DISCOUNT_FORM'
export const GET_ALL_DISCOUNTS = 'GET_ALL_DISCOUNTS'
export const GET_DISCOUNT_TYPES = 'GET_DISCOUNT_TYPES'
export const GET_DISCOUNT_FORM = 'GET_DISCOUNT_FORM'
export const SUBMIT_DISCOUNT_FORM = 'SUBMIT_DISCOUNT_FORM'
export const UPDATE_DISCOUNT_ACTIVITY = 'UPDATE_DISCOUNT_ACTIVITY'
export const UPDATE_DISCOUNT_ACTIVITY_PENDING = 'UPDATE_DISCOUNT_ACTIVITY_PENDING'
export const DELETE_DISCOUNT = 'DELETE_DISCOUNT'
